export function login({ payload }) {
  let data = new FormData()
  data.append('_username', payload.username)
  data.append('_password', payload.password)

  return {
    url: `/api/login`,
    method: 'POST',
    headers: {
      Accept: 'application/json',
    },
    body: data,
  }
}

export function refresh({ params }) {
  let data = new FormData()
  data.append('refresh_token', params.token)

  return {
    url: `/api/token/refresh`,
    method: 'POST',
    headers: {
      Accept: 'application/json',
    },
    body: data,
  }
}
